import React, { useEffect, useState } from "react";
import axios from "axios";
import SearchableDropdown from "./SearchableDropdown";
import { SERVER_URL } from "../config";
import { PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";

const INPUT_CLASS =
  "w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors";

const INPUT_READONLY =
  "w-full bg-slate-100 border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-400 cursor-not-allowed select-none";

const FieldLabel = ({ children }) => (
  <label className="text-xs text-slate-500 font-medium">
    {children}
  </label>
);

const SectionTitle = ({ children }) => (
  <div className="flex items-center gap-2 mb-3 mt-1">
    <div
      className="w-1 h-4 rounded-full flex-shrink-0"
      style={{ background: "linear-gradient(180deg, #1e40af, #0369a1)" }}
    />
    <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500 m-0">
      {children}
    </p>
  </div>
);

const AddEmployeeModal = ({ onClose, refreshData, employeeData = null }) => {
  const isEditMode = Boolean(employeeData);
  const [isEditing, setIsEditing] = useState(!isEditMode);
  const [saturdayLeave, setSaturdayLeave] = useState(
    employeeData?.saturday_leave || ""
  );


  const [regions] = useState([
    { label: "Kolkata", value: "Kolkata" },
    { label: "Ranchi", value: "Ranchi" },
    { label: "Bangladesh", value: "Bangladesh" },
  ]);

  const [roles] = useState([
    { label: "Developer", value: "Developer" },
    { label: "HR", value: "HR" },
    { label: "Manager/Admin", value: "Manager/Admin" },
    { label: "Telecaller", value: "Telecaller" },
    { label: "Support", value: "Support" },
    { label: "Sales", value: "Sales" },
  ]);

  const [designations] = useState([
    { label: "Junior", value: "Junior" },
    { label: "Senior", value: "Senior" },
    { label: "Team Lead", value: "Team Lead" },
    { label: "Manager", value: "Manager" },
    { label: "Intern", value: "Intern" },
  ]);

  const [departments] = useState([
    { label: "IT", value: "IT" },
    { label: "HR", value: "HR" },
    { label: "Sales", value: "Sales" },
    { label: "Support", value: "Support" },
    { label: "Accounts", value: "Accounts" },
    { label: "Operations", value: "Operations" },
  ]);

  const [employmentTypes] = useState([
    { label: "Admin", value: "Admin" },
    { label: "Employee", value: "Employee" },
  ]);

  const [saturdayLeaves] = useState([
    { label: "None", value: "None" },
    { label: "1st Saturday", value: "1st Saturday" },
    { label: "2nd Saturday", value: "2nd Saturday" },
    { label: "3rd Saturday", value: "3rd Saturday" },
    { label: "4th Saturday", value: "4th Saturday" },
    { label: "5th Saturday", value: "5th Saturday" },
    { label: "1st & 3rd Saturday", value: "1st & 3rd Saturday" },
    { label: "2nd & 4th Saturday", value: "2nd & 4th Saturday" },
    { label: "All Saturdays", value: "All Saturdays" },
  ]);

  const [form, setForm] = useState({
    employee_id: "", employee_name: "", email: "", region: "", dob: "",
    job_role: "", job_designation: "", department: "", employeementType: "",
    saturday_leave: "", check_in_time: "", check_out_time: "", password: "123", city: "", address: "", join_date: "", phone: "",
    pf_account: "", pan_number: "", bank_name: "", account_number: "",
    ifsc_code: "", basic_pay: "", hra: "", ta: "", da: "", esi_number: "",
  });

  useEffect(() => {
  if (isEditMode) {
    setForm({
      employee_id: employeeData.employee_id,
      employee_name: employeeData.employee_name || "",
      email: employeeData.email || "",
      region: employeeData.region || "",
      dob: employeeData.DOB || "",
      job_role: employeeData.job_role || "",
      job_designation: employeeData.job_position || "",
      department: employeeData.department || "",
      employeementType: employeeData.privilages === 2 ? "Admin" : "Employee",
      saturday_leave: employeeData.leaveDays || "",
      check_in_time: employeeData.in_time || "",
      check_out_time: employeeData.out_time || "",
      password: "123",
      city: employeeData.city || "",
      address: employeeData.address || "",
      join_date: employeeData.join_date || "",
      phone: employeeData.number || "",
      pf_account: employeeData.pf_acc_no || "",
      pan_number: employeeData.pan_no || "",
      bank_name: employeeData.bank_name || "",
      account_number: employeeData.bank_acc_no || "",
      ifsc_code: employeeData.ifsc_code || "",
      basic_pay: employeeData.basic_pay || "",
      hra: employeeData.hra || "",
      ta: employeeData.travel_allowance || "",
      da: employeeData.duty_allowance || "",
      esi_number: employeeData.esi_acc_no || "",
    });
    setIsEditing(false);
  } else {
    // Fetch the employee ID when in add mode
    const fetchEmployeeId = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/Rahul/createEmployee.php`);
        if (response.data && response.data.employee_id) {
          setForm((prev) => ({ ...prev, employee_id: response.data.employee_id }));
        }
      } catch (error) {
        console.error("Error fetching employee ID:", error);
        // Set a default fallback
        setForm((prev) => ({ ...prev, employee_id: "SBE/1001" }));
      }
    };
    fetchEmployeeId();
  }
}, [employeeData, isEditMode]); // Add isEditMode to dependencies

  const handleChange = (name, value) => setForm((prev) => ({ ...prev, [name]: value }));

  const validateForm = () => {
    const requiredFields = ["employee_name", "email", "region", "dob", "job_role", "job_designation", "department", "employeementType", "saturday_leave"];
    for (let field of requiredFields) {
      if (!form[field]) { alert("Please fill all required (*) fields."); return false; }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const payload = {
      employee_id: form.employee_id, employee_name: form.employee_name, email: form.email,
      username: form.email, region: form.region, DOB: form.dob, job_role: form.job_role,
      job_position: form.job_designation, department: form.department,
      privilages: form.employeementType === "Admin" ? 2 : 1, saturday_leave: form.saturday_leave, in_time: form.check_in_time,
      out_time: form.check_out_time,password: form.password,
      city: form.city, address: form.address, join_date: form.join_date, number: form.phone,
      pf_acc_no: form.pf_account, pan_no: form.pan_number, bank_name: form.bank_name,
      bank_acc_no: form.account_number, ifsc_code: form.ifsc_code, basic_pay: form.basic_pay,
      hra: form.hra, travel_allowance: form.ta, duty_allowance: form.da, esi_acc_no: form.esi_number,
    };
    try {
      const url = isEditMode ? `${SERVER_URL}/Rahul/updateEmployeeDetails.php` : `${SERVER_URL}/Rahul/createEmployee.php`;
      const response = await axios.post(url, payload, { headers: { "Content-Type": "application/json" } });
      if (response.data.status) {
        alert(isEditMode ? "Employee updated successfully!" : "Employee added successfully!");
        refreshData();
        onClose();
      } else {
        alert(response.data.message || "Failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: "rgba(15,23,42,0.55)", backdropFilter: "blur(8px)" }}
    >
      {/* Top accent line */}
      <div
        className="fixed top-0 left-0 right-0 h-0.5 z-50"
        style={{ background: "linear-gradient(90deg, #1e40af 0%, #0369a1 50%, #0e7490 100%)" }}
      />

      <div
        className="w-[680px] max-h-[90vh] rounded-xl flex flex-col bg-white border border-slate-200"
        style={{ boxShadow: "0 20px 60px rgba(15,23,42,0.18)" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Header ── */}
        <div
          className="px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0 bg-white rounded-t-xl"
          style={{ boxShadow: "0 1px 4px rgba(15,23,42,0.06)" }}
        >
          <div className="flex items-center gap-2.5">
            <div
              className="w-1 h-6 rounded-full"
              style={{ background: "linear-gradient(180deg, #1e40af, #0369a1)" }}
            />
            <h3 className="text-lg font-bold m-0 tracking-tight text-slate-800">
              {isEditMode ? "Edit Employee" : "Add New Employee"}
            </h3>
          </div>
          <div className="flex items-center gap-2">
            {isEditMode && !isEditing && (
              <button
                type="button"
                onClick={() => setIsEditing(true)}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-emerald-700 border border-emerald-200 bg-emerald-50 hover:bg-emerald-100 transition-colors"
              >
                <PencilIcon className="h-3.5 w-3.5" />
                Edit
              </button>
            )}
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
        </div>

        {/* ── Form ── */}
        <form
          onSubmit={handleSubmit}
          className="flex-1 overflow-y-auto px-6 py-5"
          style={{
            background: "#f0f4f8",
            scrollbarWidth: "thin",
            scrollbarColor: "rgba(148,163,184,0.5) rgba(241,245,249,1)"
          }}
        >

          {/* ── Basic Info ── */}
          <SectionTitle>Basic Information</SectionTitle>
          <div
            className="rounded-xl bg-white border border-slate-200 p-4 mb-4"
            style={{ boxShadow: "0 1px 6px rgba(15,23,42,0.06)" }}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

              <div className="flex flex-col gap-1">
                <FieldLabel>Employee ID *</FieldLabel>
                <input name="employee_id" value={form.employee_id} readOnly className={INPUT_READONLY} />
              </div>

              <div className="flex flex-col gap-1">
                <FieldLabel>Employee Name *</FieldLabel>
                <input
                  required name="employee_name" placeholder="Enter full name"
                  value={form.employee_name} disabled={!isEditing}
                  className={isEditing ? INPUT_CLASS : INPUT_READONLY}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-1">
                <FieldLabel>Email / Username *</FieldLabel>
                <input
                  required name="email" placeholder="example@company.com"
                  value={form.email} disabled={!isEditing}
                  className={isEditing ? INPUT_CLASS : INPUT_READONLY}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </div>

              <SearchableDropdown
                label="Region *" options={regions} value={form.region}
                disabled={!isEditing} onChange={(val) => handleChange("region", val)}
                placeholder="Select working region"
              />

              <div className="flex flex-col gap-1">
                <FieldLabel>Date of Birth *</FieldLabel>
                <input
                  type="date" required name="dob" value={form.dob} disabled={!isEditing}
                  className={isEditing ? INPUT_CLASS : INPUT_READONLY}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-1">
                <FieldLabel>Password *</FieldLabel>
                <input name="password" value={form.password} readOnly className={INPUT_READONLY} />
              </div>
            </div>
          </div>

          {/* ── Role & Department ── */}
          <SectionTitle>Role & Department</SectionTitle>
          <div
            className="rounded-xl bg-white border border-slate-200 p-4 mb-4"
            style={{ boxShadow: "0 1px 6px rgba(15,23,42,0.06)" }}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <SearchableDropdown
                label="Job Role *" options={roles} value={form.job_role}
                disabled={!isEditing} onChange={(val) => handleChange("job_role", val)}
                placeholder="Select job role"
              />
              <SearchableDropdown
                label="Job Designation *" options={designations} value={form.job_designation}
                disabled={!isEditing} onChange={(val) => handleChange("job_designation", val)}
                placeholder="Select designation"
              />
              <SearchableDropdown
                label="Department *" options={departments} value={form.department}
                disabled={!isEditing} onChange={(val) => handleChange("department", val)}
                placeholder="Select department"
              />
              <SearchableDropdown
                label="Employment Type *" options={employmentTypes} value={form.employeementType}
                disabled={!isEditing} onChange={(val) => handleChange("employeementType", val)}
                placeholder="Select employment type"
              />
              <div className="flex flex-col gap-1">
                <FieldLabel>Check In Time</FieldLabel>
                <input
                  type="time"
                  name="check_in_time"
                  value={form.check_in_time}
                  disabled={!isEditing}
                  className={isEditing ? INPUT_CLASS : INPUT_READONLY}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-1">
                <FieldLabel>Check Out Time</FieldLabel>
                <input
                  type="time"
                  name="check_out_time"
                  value={form.check_out_time}
                  disabled={!isEditing}
                  className={isEditing ? INPUT_CLASS : INPUT_READONLY}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </div>
              <SearchableDropdown
                label="Saturday Leave"
                options={saturdayLeaves}
                value={form.saturday_leave}
                disabled={!isEditing}
                onChange={(val) => handleChange("saturday_leave", val)}
                placeholder="Select Saturday Leave"
              />
            </div>
          </div>

          {/* ── Contact & Address ── */}
          <SectionTitle>Contact & Address</SectionTitle>
          <div
            className="rounded-xl bg-white border border-slate-200 p-4 mb-4"
            style={{ boxShadow: "0 1px 6px rgba(15,23,42,0.06)" }}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { name: "city", label: "City", placeholder: "Enter city", type: "text" },
                { name: "address", label: "Address", placeholder: "Enter address", type: "text" },
                { name: "join_date", label: "Joining Date", placeholder: "", type: "date" },
                { name: "phone", label: "Mobile Number", placeholder: "Enter mobile number", type: "text" },
              ].map(f => (
                <div key={f.name} className="flex flex-col gap-1">
                  <FieldLabel>{f.label}</FieldLabel>
                  <input
                    type={f.type} name={f.name} placeholder={f.placeholder}
                    value={form[f.name]} disabled={!isEditing}
                    className={isEditing ? INPUT_CLASS : INPUT_READONLY}
                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* ── Financial & Compliance ── */}
          <SectionTitle>Financial & Compliance</SectionTitle>
          <div
            className="rounded-xl bg-white border border-slate-200 p-4 mb-4"
            style={{ boxShadow: "0 1px 6px rgba(15,23,42,0.06)" }}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { name: "pf_account", label: "PF Account Number", placeholder: "Enter PF account number", type: "text" },
                { name: "pan_number", label: "PAN Number", placeholder: "Enter PAN number", type: "text" },
                { name: "bank_name", label: "Bank Name", placeholder: "Enter bank name", type: "text" },
                { name: "account_number", label: "Account Number", placeholder: "Enter account number", type: "text" },
                { name: "ifsc_code", label: "IFSC Code", placeholder: "Enter IFSC code", type: "text" },
                { name: "esi_number", label: "ESI Number", placeholder: "Enter ESI number", type: "text" },
                { name: "basic_pay", label: "Basic Pay", placeholder: "Enter basic pay", type: "number" },
                { name: "hra", label: "HRA", placeholder: "Enter HRA", type: "number" },
                { name: "ta", label: "TA (Travel Allowance)", placeholder: "Enter Travel Allowance", type: "number" },
                { name: "da", label: "DA (Dearness Allowance)", placeholder: "Enter Dearness Allowance", type: "number" },
              ].map(f => (
                <div key={f.name} className="flex flex-col gap-1">
                  <FieldLabel>{f.label}</FieldLabel>
                  <input
                    type={f.type} name={f.name} placeholder={f.placeholder}
                    value={form[f.name]} disabled={!isEditing}
                    className={isEditing ? INPUT_CLASS : INPUT_READONLY}
                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* ── Actions ── */}
          {isEditing && (
            <div className="flex justify-end gap-3 pt-1 pb-1">
              <button
                type="button" onClick={onClose}
                className="px-5 py-2 rounded-lg text-sm font-semibold text-slate-600 border border-slate-200 hover:bg-slate-50 bg-white transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-5 py-2 rounded-lg text-sm font-bold text-white transition-all"
                style={{ background: "linear-gradient(135deg, #1e40af, #0369a1)" }}
              >
                {isEditMode ? "Update Details" : "Save Employee"}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddEmployeeModal;